import { render, staticRenderFns } from "./back-icon.svg.vue?vue&type=template&id=de730e5e&"
import script from "./back-icon.svg.vue?vue&type=script&lang=js&"
export * from "./back-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports